export const path = {
    "HOME": `${process.env.GATSBY_FORCE_HOST}/`,
    "DEDHAM": `${process.env.GATSBY_FORCE_HOST}/dedham`,
    "COOLIDGE": `${process.env.GATSBY_FORCE_HOST}/coolidge`,
    "BROOKLINE": `${process.env.GATSBY_FORCE_HOST}/verndale`,
    "ACUPUNCTURE": `${process.env.GATSBY_FORCE_HOST}/acupuncture`,
    "FAQ": `${process.env.GATSBY_FORCE_HOST}/frequently-asked-questions`,
    "COMMUNITY_ACUPUNCTURE": `${process.env.GATSBY_FORCE_HOST}/community-acupuncture`,
    "FRA": `${process.env.GATSBY_FORCE_HOST}/facial-rejuvenation-acupuncture`,
    "ASKDIETITIAN": `${process.env.GATSBY_FORCE_HOST}/ask-dietitian`,
    "FUNCNUTR": `${process.env.GATSBY_FORCE_HOST}/functional-nutrition`,
    "HERBAL_MEDICINE": `${process.env.GATSBY_FORCE_HOST}/herbal-medicine`,
    "INFRARED_SAUNA": `${process.env.GATSBY_FORCE_HOST}/infrared-sauna`,
    "LED_LASER": `${process.env.GATSBY_FORCE_HOST}/led-laser`,
    "FACEBOOK": "https://www.facebook.com/AcuBoston/",
    "INSTAGRAM": "https://www.instagram.com/acuboston/",
    "YOUTUBE": "https://www.youtube.com/channel/UCnnOjXUuq59wrVxnFrtmfEA",
    "TIKTOK": "https://www.tiktok.com/@acuboston_",
    "SITEMAP": `${process.env.GATSBY_FORCE_HOST}/site-map`,
    "TOS": `${process.env.GATSBY_FORCE_HOST}/tos`,
    "ACCESSIBILITY": `${process.env.GATSBY_FORCE_HOST}/accessibility`,
    "PRIVACY_POLICY": `${process.env.GATSBY_FORCE_HOST}/privacy-policy`,
    // "IVF": "/ivf",
}